import {Link} from 'react-router-dom';
import React from 'react';

const NotFound = () => {
  return (
    <div className="not-found">
      <h1>404</h1>
      <h1>Page Not Found</h1>
      <p>Sorry, the page you are looking for does not exist.</p>
      <Link className="item" to="/Home">返回首页</Link>
    </div>
  );
};

export default NotFound;
